var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGauge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 15,
    viewBox: "0 0 29 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40234 12.7215L1 10.2673C2.15063 7.66556 4.0316 5.45366 6.41468 3.89997C8.79776 2.34627 11.5805 1.51758 14.4253 1.51441C17.2702 1.51125 20.0548 2.33376 22.4413 3.88215C24.8278 5.43054 26.7137 7.63826 27.8701 10.2374L22.4125 12.6668C21.7258 11.1262 20.6077 9.81732 19.1932 8.89844C17.7787 7.97955 16.1284 7.48995 14.4416 7.48878C12.7405 7.4962 11.0775 7.99369 9.65171 8.92171C8.22594 9.84973 7.09781 11.1689 6.40234 12.7215Z",
    stroke: "#EBEDF0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6177 1.72815V3.45446",
    stroke: "#EBEDF0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60645 2.99646L9.23694 4.603",
    stroke: "#EBEDF0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53174 6.24878L4.82468 7.39239",
    stroke: "#EBEDF0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2494 2.99646L19.6187 4.603",
    stroke: "#EBEDF0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3238 6.24878L21.0176 10.1569",
    stroke: "#EBEDF0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6083 13.918C15.4749 13.918 16.1775 13.2154 16.1775 12.3488C16.1775 11.4821 15.4749 10.7795 14.6083 10.7795C13.7416 10.7795 13.0391 11.4821 13.0391 12.3488C13.0391 13.2154 13.7416 13.918 14.6083 13.918Z",
    stroke: "#EBEDF0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7524 4.40649L15.1641 10.8802",
    stroke: "#EBEDF0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1479 10.2883L22.4633 12.327L27.6584 10.0912L25.2251 6.27686L21.1479 10.2883Z",
    fill: "#EBEDF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/Gauge.8c8076e7.svg";
export { ForwardRef as ReactComponent };